import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

import rootReducer from "./slices";
import { clearPersistData } from "./slices/PersistData/reducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist:["StoredData"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck:false,
    }),
});

export const persistor = persistStore(store);

export const resetStore = () => {
  // persistor.pause();
  persistor.purge().then(() => {
   store.dispatch(clearPersistData());
  });
  
};
export const resetAll = () => ({ type: "RESET_ALL" });
